import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { ProtectedRoute } from '@/components/layout/ProtectedRoute';

const RolesPage = lazy(() => import('./RolesPage'));
const RoleDetailPage = lazy(() => import('./RoleDetailPage'));

export const roleRoutes: RouteObject[] = [
  {
    path: 'roles',
    element: (
      <ProtectedRoute action="roles:view">
        <RolesPage />
      </ProtectedRoute>
    ),
  },
  {
    path: 'roles/:id',
    element: (
      <ProtectedRoute action="roles:view">
        <RoleDetailPage />
      </ProtectedRoute>
    ),
  },
];
